export enum CheckoutStep {
  SELECT_MEMBERSHIP = 0,
  CUSTOMER_INFO = 1,
  PAYMENT = 2,
  CONFIRMATION = 3,
}
